<template>
	<div class="container__plantiosEstrato">
		<GmapMap
			ref="map"
			map-type-id="satellite"
			class="container__googlemaps__position"
			:center="{ lat: -17.390269, lng: -40.538804 }"
			:zoom="16"
			@click="fecharTodosInfoWindow"
		>
			<template #visible>
				<!-- Movido para dentro dos controles do Google no mounted: v-show em vez de v-if,
				     senão o Vue recriaria o elemento fora do mapa -->
				<div
					v-show="parcelas.length"
					ref="switcherCodigoDaParcela"
					class="container__switcher__codigo__parcela"
				>
					<Switcher
						v-model="exibirCodigoDaParcela"
						:label="$t('showPlotId')"
					/>
				</div>
			</template>

			<PolygonShape
				:editable="false"
				:options="shapeOptionsFzda"
				:coordinates="getGeoJsonFzda.coordinates"
				:type="getGeoJsonFzda.type"
				:clickable="true"
				@click="
					ordemServico.tpsv_cd_codigo === '009'
						? placeMarker
						: () => {
								return false
							}
				"
			/>
			<PolygonShape
				v-for="(coordinateAndType, index) in getGeoJsonTlho.features"
				:key="`T-${index}`"
				:editable="false"
				:options="{
					fillColor: 'gray',
					strokeColor: 'gray',
					strokeOpacity: 0.6,
					fillOpacity: 0.4,
					strokeWeight: 2,
					zIndex: 10,
				}"
				:coordinates="coordinateAndType.coordinates"
				:type="coordinateAndType.type"
				:clickable="true"
			/>
			<PolygonShape
				v-for="coordinateAndType in getGeoJsonPtio.features"
				:key="coordinateAndType.properties['Codigo Plantio']"
				:editable="false"
				:position="coordinateAndType.position"
				:options="shapeOptionsPtio(coordinateAndType.properties)"
				:coordinates="coordinateAndType.coordinates"
				:type="coordinateAndType.type"
				:properties="coordinateAndType.properties"
				:clickable="true"
				@click="placeMarker"
			/>

			<PolygonShape
				v-for="coordinateAndType in getGeoJsonBufferTalhao.features"
				:key="'Buffer-' + coordinateAndType.properties['Codigo Plantio']"
				:editable="false"
				:position="coordinateAndType.position"
				:options="shapeOptionsPtio(coordinateAndType.properties)"
				:coordinates="coordinateAndType.coordinates"
				:type="coordinateAndType.type"
				:properties="coordinateAndType.properties"
				:clickable="true"
				@click="placeMarker"
			/>
			<PolygonShape
				v-for="(coordinateAndType, index) in getGeoJsonBufferParcela.features"
				:key="'BufferParcela-' + index"
				:editable="false"
				:position="coordinateAndType.position"
				:options="shapeOptionsPtio(coordinateAndType.properties)"
				:coordinates="coordinateAndType.coordinates"
				:type="coordinateAndType.type"
				:clickable="true"
				:click="placeMarker"
			/>

			<!-- <ParcelaMarker
        v-for="(parcela, index) in parcelas"
        :key="`${index}-parcela`"
        :plantioMarker="parcela"
      /> -->

			<GmapMarker
				v-for="(parcela, index) in parcelas"
				:key="`${parcela.codigo}_${index}`"
				:position="{ lat: Number(parcela.coordenadaY), lng: Number(parcela.coordenadaX) }"
				:clickable="true"
				:draggable="parcela.icon.draggable"
				:icon="iconeDoMarcadorPorColeta(parcela)"
				:label="rotuloDoMarcador(parcela)"
				@click="openInfoWindow(parcela)"
				@dragend="updateCoordinates($event, parcela.id)"
			>
				<GmapInfoWindow
					:ref="`${parcela.codigo}_${parcela.plantioId}`"
					:opened="abrirInfoWindow(parcela)"
					@closeclick="fecharTodosInfoWindow"
				>
					<AmostraInfo
						v-if="ordemServico.tpsv_cd_codigo === '007'"
						:amostra-info="parcela"
					/>
					<ConcentradorInfo
						v-else-if="ordemServico.tpsv_cd_codigo === '009'"
						:id="index + 1"
						:concentrador-info="parcela"
					/>
					<ParcelaInfo
						v-else
						:parcela-info="parcela"
						:ordem-servico-id="ordemServico.id"
						:data-fechamento-o-s="ordemServico.orsv_dt_data_final"
						@desconsideraParcela="desconsiderarParcela($event)"
					/>
				</GmapInfoWindow>
			</GmapMarker>
			<div v-if="Object.entries(getGeoJsonPrcla).length">
				<GmapMarker
					v-for="m in getGeoJsonPrcla.features"
					:key="m.codigo"
					:position="{ lat: Number(m.coordinates[1]), lng: Number(m.coordinates[0]) }"
					:clickable="true"
					:draggable="true"
					:icon="iconeParcela({ codigo: m.properties.Parcela, draggable: true })"
				/>
			</div>

			<div v-if="showInfoPlantio">
				<PlantioMarker
					v-for="(plantioMarker, index) in plantioMarkers"
					:key="`${index}-plantioMarker`"
					:plantio-marker="plantioMarker"
				/>
			</div>
		</GmapMap>
	</div>
</template>
<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import SHAPE_OPTIONS_FZDA from '../../../constants/ShapeOptions/ShapeFzda'
import { SHAPE_OPTIONS_PLANTIO_POLIGONO_ORDEM_SERVICO } from '../../../constants/ShapeOptions/ShapePtio'
import SHAPE_OPTIONS_TLHO from '../../../constants/ShapeOptions/ShapeTlho'

import AmostraInfo from '../../../components/AmostraInfo/AmostraInfo'
import ConcentradorInfo from '../../../components/ConcentradorInfo/ConcentradorInfo'
import PolygonShape from '../../../components/Map/PolygonShape'
import ParcelaInfo from '../../../components/ParcelaInfo/ParcelaInfo'
import PlantioMarker from '../../../components/PlantioMarker/PantioMarker.vue'
import Switcher from '../../../components/Switcher/Switcher.vue'

import { v4 as uuidv4 } from 'uuid'

// import ParcelaMarker from "../../../components/ParcelaMarker/ParcelaMarker";

import * as turf from '@turf/turf'

export default {
	components: {
		PolygonShape,
		ParcelaInfo,
		AmostraInfo,
		ConcentradorInfo,
		PlantioMarker,
		Switcher,
		// ParcelaMarker
	},

	computed: {
		...mapGetters('moduleImportShape', [
			'getGeoJsonFzda',
			'plantioMarkers',
			'getGeoJsonTlho',
			'getGeoJsonPtio',
			'getGeoJsonBufferTalhao',
			'isGeoJsonBufferTalhaoEmpty',
			'getGeoJsonBufferParcela',
			'getGeoJsonPrcla',
		]),
		plantioMarkersParcelaInfo() {
			return this.plantioMarkers.map((plantioMarker) => {
				return Object.assign(plantioMarker, {
					intensidadeAmostral:
						plantioMarker.area /
						this.parcelas.filter((parcela) => parcela.plantioId === plantioMarker.infoPoligono.id)
							.length,
				})
			})
		},

		jaPossuiParcelasSalvasNoBanco() {
			return this.parcelas.some((parcela) => parcela.existente)
		},
	},

	watch: {
		'$store.state.moduleImportShape.geoJsonPrcla': {
			handler(value) {
				const parcelas = value.features
					.filter((marcador) =>
						this.getGeoJsonPtio.geojson.features.some((plantio) =>
							turf.booleanPointInPolygon(turf.point(marcador.coordinates), plantio),
						),
					)
					.map((parcela) => {
						return Object.assign(parcela.properties, {
							// codigo: parcela.properties.Parcela,
							coordenadaX: parcela.coordinates[0],
							coordenadaY: parcela.coordinates[1],
							icon: this.iconeParcela({
								// codigo: parcela.properties.Parcela,
								draggable: true,
								selected: true,
							}),
							id: uuidv4(),
							infoOpened: false,
							plantioId: this.getGeoJsonPtio.geojson.features.find((plantio) => {
								return turf.booleanPointInPolygon(turf.point(parcela.coordinates), plantio)
							}).properties.idPlantio,
						})
					})
				console.log('🚀 ~ file: PlanejamentoOrdemServico.vue:217 ~ handler ~ parcelas:', parcelas)
				this.parcelas.splice(0, this.parcelas.length)
				this.parcelas.push(...parcelas)
			},
		},
		'$store.state.moduleImportShape.bounds': {
			// immediate: true,
			deep: true,
			handler(value) {
				console.log('🚀 ~ file: PlanejamentoOrdemServico.vue:188 ~ handler ~ value', value)
				if (Object.keys(value).length > 0 && this.$refs.map) {
					this.$refs.map.$mapPromise.then((map) => {
						map.fitBounds(value, 0)
					})
				}
			},
		},
		parcelas: {
			deep: true,
			handler(parcelas) {
				this.infoWindowReferenciaDoMarcador = []
				this.infoWindowReferenciaDoMarcador = parcelas.map((parcela) => {
					return {
						codigoReferencia: `${parcela.codigo}_${parcela.plantioId}`,
						exibirInfoWindow: false,
					}
				})
			},
		},
	},

	mounted() {
		const { map } = this.$refs
		const value = this.$store.state.moduleImportShape.bounds

		setTimeout(() => {
			map.fitBounds(value, 0)
		}, 1000)

		// O painel da OS cobre o lado direito do mapa, onde o Google posiciona os controles por
		// padrão: empilha todos à esquerda, abaixo do seletor Mapa / Satélite
		map.$mapPromise.then((mapa) => {
			const { LEFT_TOP, TOP_LEFT } = window.google.maps.ControlPosition

			mapa.setOptions({
				fullscreenControlOptions: { position: LEFT_TOP },
				streetViewControlOptions: { position: LEFT_TOP },
				cameraControlOptions: { position: LEFT_TOP },
				zoomControlOptions: { position: LEFT_TOP },
			})

			// Registrado como controle do mapa, o Google o alinha ao lado do seletor Mapa / Satélite
			mapa.controls[TOP_LEFT].push(this.$refs.switcherCodigoDaParcela)
		})
	},

	created() {
		this.infoWindowReferenciaDoMarcador = this.parcelas.map((parcela) => {
			return {
				codigoReferencia: `${parcela.codigo}_${parcela.plantioId}`,
				exibirInfoWindow: false,
			}
		})
	},

	methods: {
		/**
		 * Parcelas coletadas (com data de fechamento) ficam verdes e as não coletadas azuis, em
		 * todos os tipos de OS - inclusive pré-corte, cujas parcelas novas eram vermelhas.
		 * Calculado no template para refletir na hora o fechar / reabrir parcela do ParcelaInfo,
		 * que altera 'dataDeFechamento' diretamente
		 * @param {Object} parcela marcador exibido no mapa
		 * @returns {Object} ícone do GmapMarker
		 */
		iconeDoMarcadorPorColeta(parcela) {
			return {
				...parcela.icon,
				fillColor: parcela.dataDeFechamento ? 'green' : 'blue',
				// Sem deslocar a origem, o Google centraliza o rótulo sobre o círculo e o texto
				// fica ilegível. A unidade é a do símbolo, multiplicada pelo 'scale' do ícone
				...(this.exibirCodigoDaParcela && window.google
					? { labelOrigin: new window.google.maps.Point(0, -2.6) }
					: {}),
			}
		},
		/**
		 * Rótulo com o ID (código) da parcela, exibido quando o switcher do mapa está ligado
		 * @param {Object} parcela marcador exibido no mapa
		 * @returns {Object|null} rótulo do GmapMarker, null para não exibir
		 */
		rotuloDoMarcador(parcela) {
			if (!this.exibirCodigoDaParcela || parcela.codigo == null) return null

			return {
				text: String(parcela.codigo),
				color: 'white',
				fontSize: '11px',
				fontWeight: '600',
			}
		},
		desconsiderarParcela(event) {
			var parcelaDesconsiderada = this.parcelas.find((parcela) => parcela.codigo === event)
			this.parcelas.splice(this.parcelas.indexOf(parcelaDesconsiderada), 1)

			this.$emit('deleteParcela', parcelaDesconsiderada.id)
		},
		abrirInfoWindow(marcador) {
			return this.infoWindowReferenciaDoMarcador.find(
				(parcela) => parcela.codigoReferencia === `${marcador.codigo}_${marcador.plantioId}`,
			).exibirInfoWindow
		},
		openInfoWindow(marcador) {
			this.fecharTodosInfoWindow()
			this.infoWindowReferenciaDoMarcador.find(
				(parcela) => parcela.codigoReferencia === `${marcador.codigo}_${marcador.plantioId}`,
			).exibirInfoWindow = true
		},
		fecharTodosInfoWindow() {
			this.infoWindowReferenciaDoMarcador.forEach((marcador) => {
				marcador.exibirInfoWindow = false
			})
		},
		updateCoordinates(event, idParcela) {
			const point = turf.point([event.latLng.lng(), event.latLng.lat()])

			const parcela = this.parcelas.find((parcela) => parcela.id === idParcela)

			if (this.isInAnyPlantio(point)) {
				this.parcelas.forEach((parcela) => {
					if (parcela.id === idParcela) {
						let plantioProperties = this.findPlantioGeoByPoint({
							coordenadaX: event.latLng.lng(),
							coordenadaY: event.latLng.lat(),
						}).properties

						parcela.coordenadaX = event.latLng.lng()
						parcela.coordenadaY = event.latLng.lat()

						if (this.isSingleTrees && parcela.plantioId !== plantioProperties.idPlantio) {
							// Verifica se a parcela mudou de plantio caso tenha trocado, deve alterar seu código com algum valor disponivel
							const codigosEmUso = this.parcelas
								.filter((amostra) => amostra.plantioId === plantioProperties.idPlantio)
								.map((amostra) => amostra.codigo)
								.sort((a, b) => b - a)

							// Percorre os codigos ate achar algum que esteja disponivel
							var codigoDisponivel = 1
							while (codigosEmUso.includes(codigoDisponivel)) codigoDisponivel++

							// Seta o novo codigo para a amostra alem de setar o novo plantio
							parcela.codigo = codigoDisponivel
							parcela.plantioId = plantioProperties.idPlantio
						} else if (!this.isSingleTrees) {
							// Recupera quais os códigos de parcela que já estão em uso no banco dentro do plantio de destino que a parcela foi colocada
							const codigosDeParcelaEmUsoNoBanco = this.codigoDeParcelaEmUsoNoBanco.find(
								(parcelaEmUso) => parcelaEmUso.plantioId == plantioProperties.idPlantio,
							).codigosExistentes

							// Busca todas as parcelas do plantio de destino que a parcela foi colocada
							const codigosDeParcelasAtuais = this.parcelas
								.filter(
									(parcela) =>
										parcela.codigo.includes(`T${plantioProperties['Codigo do Talhao']}`) &&
										parcela.plantioId == plantioProperties.idPlantio,
								)
								.map((m) =>
									Number.parseInt(
										m.codigo.replace(
											/^T([ÁÉÍÓÚÀÈÌÒÙÃÕÂÊÎÔÛÄËÏÖÜÝÅÆØÇÑÕÆßáéíóúãõâêîôû/\w-]+)_P/,
											'',
										),
									),
								)

							// Codigos sem repeticao
							const codigosUnicos = [
								...new Set(codigosDeParcelaEmUsoNoBanco.concat(codigosDeParcelasAtuais)),
							]

							// Remove o codigo da parcela que foi movida por ela poder manter o próprio código caso ela tenha sido movida dentro do mesmo plantio
							if (
								/^T([ÁÉÍÓÚÀÈÌÒÙÃÕÂÊÎÔÛÄËÏÖÜÝÅÆØÇÑÕÆßáéíóúãõâêîôû/\w-]+)_P/.test(parcela.codigo) &&
								parcela.plantioId == plantioProperties.idPlantio
							) {
								const parcelaMovida = parcela.codigo.replace(
									/^T([ÁÉÍÓÚÀÈÌÒÙÃÕÂÊÎÔÛÄËÏÖÜÝÅÆØÇÑÕÆßáéíóúãõâêîôû/\w-]+)_P/,
									'',
								)
								const codigoDaParcelaMovida = Number.parseInt(parcelaMovida)

								const indice = codigosUnicos.indexOf(codigoDaParcelaMovida)
								codigosUnicos.splice(indice, 1)
							}

							// Atribui o id do plantio para a parcela
							parcela.plantioId = plantioProperties.idPlantio

							// Caso a lista de codigos unicos seja vazio, significa que a parcela deve comecar com 1, caso contrario, verifica qual o proximo valor disponivel
							if (codigosUnicos.length == 0)
								parcela.codigo = `T${plantioProperties['Codigo do Talhao']}_P1`
							else {
								var codigoDaParcela = 1

								while (codigosUnicos.includes(codigoDaParcela)) {
									codigoDaParcela++
								}

								// Atribui o novo codigo para a parcela
								parcela.codigo = `T${plantioProperties['Codigo do Talhao']}_P${codigoDaParcela}`
							}
						}
					}
				})

				if (parcela.id) {
					parcela.hasChanged = true
				}
			} else {
				if (parcela.id) this.$emit('deleteParcela', parcela.id)
				this.parcelas.splice(this.parcelas.indexOf(parcela), 1)
			}

			// this.validarMarcadores();
		},
		placeMarker(event) {
			// Fecha todos os infowindow quando adiciona uma nova parcela
			this.fecharTodosInfoWindow()

			// Recupera a localizacao do click
			const coordenadaX = event.latLng.lng()
			const coordenadaY = event.latLng.lat()

			// Caso exista buffer e a coordenada está fora do buffer retorna sem criar parcela
			if (
				!this.isGeoJsonBufferTalhaoEmpty &&
				!this.coordenadaDentroDoBuffer(coordenadaY, coordenadaX)
			)
				return

			// Caso seja ordem de servico de instalacao single trees, mas ja possua amostra no banco, nao deixa adicionar novas ao clicar
			if (this.ordemServico.tpsv_cd_codigo === '007' && this.jaPossuiParcelasSalvasNoBanco) return

			const plantioId = this.findPlantioGeoByPoint({ coordenadaX, coordenadaY }).properties
				.idPlantio

			// Cria a nova parcela
			const parcela = {
				codigo: this.createCodigoParcela({
					coordenadaX,
					coordenadaY,
				}),
				coordenadaX,
				coordenadaY,
				plantioId: plantioId,
				icon: this.iconeParcela({
					draggable: true,
					color: this.ordemServico.tpsv_cd_codigo === '003' ? 'red' : 'blue',
				}),
				infoOpened: false,
				id: uuidv4(),
			}

			// Adiciona aparcela na lista
			this.adicionaParcela(parcela)
			this.validarIntensidadeAmostralPorPlantio()
			//this.validarMarcadores();
		},
		// existeBuffer(){
		//   console.log(this.getGeoJsonBufferTalhao.features)
		//   return this.getGeoJsonBufferTalhao.features?.length > 0;
		// },
		coordenadaDentroDoBuffer(latitude, longitude) {
			return this.getGeoJsonBufferTalhao.features.some((feature) => {
				const marcador = turf.point([Number(longitude), Number(latitude)])
				return turf.booleanPointInPolygon(marcador, feature.geometry)
			})
		},
		...mapMutations('moduleImportShape', [
			'resetImportShapeState',
			'setGeoJsonFzda',
			'setGeoJsonTlho',
			'setGeoJsonPtio',
			'setGeoJsonPrcla',
			'setFzdaHasFileInDB',
			'setPrclaHasFileInDB',
			'setTlhoHasFileInDB',
			'setPtioHasFileInDB',
		]),
		...mapActions('moduleImportShape', ['getShapesByFazendaId']),
	},
	props: {
		ordemServico: { type: Object },
		parcelas: { type: Array },
		createCodigoParcela: { type: Function },
		findPlantioGeoByPoint: { type: Function },
		adicionaParcela: { type: Function },
		iconeParcela: { type: Function },
		isInAnyPlantio: { type: Function },
		validarMarcadores: { type: Function },
		validarIntensidadeAmostralPorPlantio: { type: Function },
		showInfoPlantio: { type: Boolean, default: false },
		codigoDeParcelaEmUsoNoBanco: { type: Array },
		isSingleTrees: { type: Boolean },
		isOrdemServicoInstalacao: { type: Boolean, default: false },
	},
	data() {
		return {
			/**
			 * Exibe o ID (código) das parcelas como rótulo dos marcadores
			 */
			exibirCodigoDaParcela: false,
			shapeOptionsFzda: SHAPE_OPTIONS_FZDA,
			shapeOptionsTlho: SHAPE_OPTIONS_TLHO,
			shapeOptionsPtio: SHAPE_OPTIONS_PLANTIO_POLIGONO_ORDEM_SERVICO,
			/**
			 * Exibe ou não o card para importar os shapes
			 */
			showImportShape: false,
			/**
			 * Exibe ou não o card para mapear colunas do shape com o sistema
			 */
			showMapData: false,
			/**
			 * Controla quais infowindow devem ser exibidos
			 */
			infoWindowReferenciaDoMarcador: [],
		}
	},
}
</script>
<style>
.container__plantiosEstrato {
	position: fixed;
	left: 0;
	top: 2.5rem;
	height: 100%;
	width: 100vw;
	z-index: 0;
	font-size: 0.75rem;
}
/* Mesma aparência do seletor Mapa / Satélite do Google, ao lado do qual fica */
.container__switcher__codigo__parcela {
	display: flex;
	align-items: center;
	height: 40px;
	margin-top: 10px;
	padding: 0 12px;
	background-color: #fff;
	border-radius: 2px;
	box-shadow: rgba(0, 0, 0, 0.3) 0 1px 4px -1px;
	font-size: 0.85rem;
}
.slider {
	-webkit-appearance: none;
	width: 100%;
	height: 15px;
	margin-bottom: 20px;

	border-radius: 5px;
	background: #d3d3d3;
	outline: none;
	opacity: 0.7;
	-webkit-transition: 0.2s;
	transition: opacity 0.2s;
}

.slider::-webkit-slider-thumb {
	-webkit-appearance: none;
	appearance: none;
	width: 25px;
	height: 25px;
	border-radius: 50%;
	background: #04aa6d;
	cursor: pointer;
}
.BackArrow {
	width: 2.5rem;
	height: 3rem;
	position: absolute;
	top: 5rem;
	right: 0%;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
}

.slider::-moz-range-thumb {
	width: 25px;
	height: 25px;
	border-radius: 50%;
	background: #04aa6d;
	cursor: pointer;
}
</style>
